module.exports = __webpack_public_path__ + "static/media/BIMpic1.933a7324.png";